<template>
  <v-container fluid>
    <v-row>
      <v-col class="py-0">
        <v-container fluid py-0>
          <v-row justify="end" align="center">
            <download-csv :data="csvData" delimiter=",">
              <v-btn small class="mr-1"
                ><v-icon left small>mdi-file-delimited</v-icon> Get CSV</v-btn
              >
            </download-csv>
            <list-visible-columns-and-filter
              :visible-columns="visibleColumns"
              :selectable-headers="selectableHeaders"
              v-model="search"
              @change="onVisibleColumnsChange"
            >
            </list-visible-columns-and-filter>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-data-table :headers="filteredHeaders" :items="items">
            <template v-slot:item.isLeader="{ item }">
              <v-icon color="teal" v-if="item.isLeader">mdi-check</v-icon>
            </template>
            <template v-slot:item.birthDate="{ item }">
              {{ item.birthDate | formatDate }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <div v-if="debug">
      {{ csvData }}
    </div>
    <v-row v-if="false">
      <v-col>
        <v-list two-line subheader>
          <template v-for="(item, index) in participants">
            <div :key="item.node.name + index">
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon class="blue white--text">mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    >{{ item.node.title }} {{ item.node.name }}
                    {{ item.node.surname }}</v-list-item-title
                  >
                  <v-list-item-subtitle>{{
                    item.node.email
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon ripple>
                    <v-icon color="grey lighten-1"
                      >mdi-information-variant</v-icon
                    >
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider inset></v-divider>
            </div>
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getValueByPath, removeGQLTypename } from "../../../helpers";
import ListVisibleColumnsAndFilter from "../shared/ListVisibleColumnsAndFilter";
import { ListMixin } from "../../../mixins/ListMixin";
export default {
  name: "ItineraryDetailsParticipantsList",

  props: {
    participants: {
      type: Array,
      defaul: () => [],
    },
  },

  mixins: [ListMixin],
  components: { ListVisibleColumnsAndFilter },

  data() {
    return {
      debug: false,
      search: "",
      visibleColumns: this.$store.getters.localSettings(this.$options.name, [
        "isLeader",
        "name",
        "surname",
        "email",
      ]),
      headers: [
        { text: "Leader", value: "isLeader", name: "isLeader" },
        { text: "Title", value: "title", name: "title" },
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Surname",
          value: "surname",
          name: "surname",
        },
        {
          text: "Email",
          value: "email",
          name: "email",
        },
        {
          text: "Mobile",
          value: "mobile",
          name: "mobile",
        },
        {
          text: "Telephone",
          value: "telephone",
          name: "telephone",
        },
        {
          text: "Age at Departure Date",
          value: "age",
          name: "age",
        },
        {
          text: "Birth Date",
          value: "birthDate",
          name: "birthDate",
        },
        {
          text: "Address",
          value: "client.address",
          name: "address",
        },
        {
          text: "Type",
          value: "clientType",
          name: "clientType",
        },
        {
          text: "Notes",
          value: "client.notes",
          name: "notes",
        },
        {
          text: "Status",
          value: "clientStatus",
          name: "clientStatus",
        },
      ],
    };
  },

  computed: {
    items() {
      return this.participants.length
        ? this.participants
            .map(removeGQLTypename)
            .map((p) => ({ ...p, ...p.client }))
        : [];
    },
    csvData() {
      return this.items.map((item) => {
        const row = {};
        for (const h of this.filteredHeaders) {
          if (item[h.value]) {
            row[h.text] = item[h.value];
          } else {
            //console.log(h);
            row[h.text] = getValueByPath(h.value, item);
          }
        }
        return row;
      });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryDetailsParticipantsList.vue